import {combineReducers} from 'redux'
import {get, isNil, mapValues} from 'lodash'
import types from 'actions/types'
import {
  mergeSellingOpportunities, removeFromSellingOpportunities,
  sortSellingOpportunityList,
  updateSellingCounts,
  updateSellingOpportunities,
  updateSellingValues,
} from 'helpers/opportunities'

export const jobTypes = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.jobTypes', state)
    default:
      return state
  }
}

export const company = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.company', state)
    default:
      return state
  }
}

export const expectedStart = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.expectedStart', state)
    default:
      return state
  }
}

export const expectedEnd = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.expectedEnd', state)
    default:
      return state
  }
}

export const expectedTimeKey = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.expectedTimeKey', state)
    default:
      return state
  }
}

export const nextActivityStart = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.nextActivityStart', state)
    default:
      return state
  }
}

export const nextActivityEnd = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.nextActivityEnd', state)
    default:
      return state
  }
}

export const nextActivityTimeKey = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_SELLING_FILTERS:
      return get(action, 'filters.nextActivityTimeKey', state)
    default:
      return state
  }
}

export const search = (state = '', action) => {
  switch (action.type) {
    case types.SALES_SEARCH_SELLING_OPPORTUNITIES:
      return action.search
    default:
      return state
  }
}

export const opportunities = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_ATTEMPT:
      return action.page !== 0
        ? state
        : {
            ...state,
            [action.stageId]: [],
          }

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_SUCCESS:
      return action.page > 0
        ? mergeSellingOpportunities(state, action.data)
        : {
          ...state,
          [action.stageId]: sortSellingOpportunityList(action.data),
        }

    case types.SALES_UPDATE_SELLING_OPPORTUNITY:
      return !isNil(action.updatedOpportunity)
        ? updateSellingOpportunities(state, action.updatedOpportunity)
        : removeFromSellingOpportunities(state, action.previousOpportunity.id)

    default:
      return state
  }
}

export const pages = (state = {}, action) => {
  switch (action.type) {
    case types.SALES_LOAD_ALL_SELLING_OPPORTUNITIES:
      return mapValues(state, () => 0)

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_ATTEMPT:
      return {
        ...state,
        [action.stageId]: isNil(action.page) ? 0 : action.page,
      }

    default:
      return state
  }
}

export const counts = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_SUCCESS:
      return isNil(action.count)
        ? state
        : {
            ...state,
            [action.stageId]: action.count,
          }

    case types.SALES_UPDATE_SELLING_OPPORTUNITY:
      return updateSellingCounts(state, action.previousOpportunity, action.updatedOpportunity)

    default:
      return state
  }
}

export const values = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_SUCCESS:
      return isNil(action.value)
          ? state
          : {
            ...state,
            [action.stageId]: action.value,
          }

    case types.SALES_UPDATE_SELLING_OPPORTUNITY:
      return updateSellingValues(state, action.previousOpportunity, action.updatedOpportunity)

    default:
      return state
  }
}

export const loading = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_ATTEMPT:
      return {
        ...state,
        [action.stageId]: true,
      }

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_SUCCESS:
      return {
        ...state,
        [action.stageId]: false,
      }

    case types.SALES_LOAD_SELLING_OPPORTUNITIES_FAILURE:
      return {
        ...state,
        [action.stageId]: false,
      }

    default:
      return state
  }
}

export default combineReducers({
  opportunities,
  counts,
  values,
  pages,
  loading,
  search,
  jobTypes,
  company,
  expectedStart,
  expectedEnd,
  expectedTimeKey,
  nextActivityStart,
  nextActivityEnd,
  nextActivityTimeKey,
})
